import { render, staticRenderFns } from "./ChangeWorkersWorkingHours.vue?vue&type=template&id=d2df027c"
import script from "./ChangeWorkersWorkingHours.vue?vue&type=script&lang=ts"
export * from "./ChangeWorkersWorkingHours.vue?vue&type=script&lang=ts"
import style0 from "./ChangeWorkersWorkingHours.vue?vue&type=style&index=0&id=d2df027c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports